import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import Button from "components/Common/Button";
import classNames from "classnames";
import colors from "stylesheets/utilities/colors.scss";
import "./styles.scss";

class GreetingPath extends React.Component {
  constructor(props) {
    super(props);

    this.handlePathRemove = this.props.handlePathRemove.bind(this);
  }

  render() {
    return (
      <div
        key={this.props.key}
        className="GreetingPath"
      >
        <div
          className={classNames(
            "GreetingPath__body", {
              "GreetingPath--invalid": this.props.invalid
            }
          )}
        >
          {this.props.path}
        </div>
        <Button
          onClick={() => {
            this.handlePathRemove(this.props.index);
          }}
          customClassName="GreetingPath__button"
          title="Remove Path"
          icon="CircleRemoveAlternate"
          fillColor={colors.colorUIBad}
          clear
        />
      </div>
    );
  }
}

GreetingPath.propTypes = {
  path: PropTypes.string.isRequired,
  invalid: PropTypes.bool,
  handlePathRemove: PropTypes.func.isRequired
};

GreetingPath.defaultProps = {
  invalid: false
};

function mapState(state) {
  return {
    greetings: state.greetings
  };
}

const Connector = connect(mapState)(GreetingPath);

export default Connector;
export { GreetingPath };
